import React, { useRef, useEffect, useState } from "react";

import "../assets/css/Home.css";

import {
  PiArrowDownLight,
  PiGlobeLight,
  PiBrainLight,
  PiUsersLight,
  PiFireLight
} from "react-icons/pi";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/all";
import NoiseBackground from "../components/Background/NoiseBackground";
import NoiseBackgroundAbsolute from "../components/Background/NoiseBackgroundAbsolute";
import { useStateContext } from "../context/ContextProvider";
import About from "../components/Home/About";
import Contact from "../components/Home/Contact";
import Services from "../components/Home/Services";
import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

function Home1({ routes }) {
  gsap.registerPlugin(ScrollTrigger);
  gsap.registerPlugin(ScrollToPlugin);

  const { isMobile, deviceSize, MARKER } = useStateContext();
  // const marker = MARKER;
  const marker = false;

  // SIDE NAV
  const [activeLink, setActiveLink] = useState("home");

  const links = [
    { id: "home", label: "Home" },
    { id: "about", label: "About" },
    { id: "services", label: "Services" },
  ];

  useEffect(() => {
    console.log("Current Device Size:", deviceSize);
    console.log("Is Mobile:", isMobile);
  }, [deviceSize, isMobile]);

  const handleLinkClick = (id) => {
    setActiveLink(id);
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const observeOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.2,
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveLink(entry.target.id);
        }
      });
    }, observeOptions);
    links.forEach((link) => {
      const section = document.getElementById(link.id);
      if (section) {
        observer.observe(section);
      }
    });
    return () => {
      links.forEach((link) => {
        const section = document.getElementById(link.id);
        if (section) {
          observer.unobserve(section);
        }
      });
    };
  }, [links]);

  // const model = useLoader(OBJLoader, greenBallObj);
  // const { nodes, materials } = useGLTF("../assets/objects/green-ball.obj");
  // const modelRef = useRef();
  // console.log("MODEL: ", model);

  // GSAP 
  const brandLogoRef = useRef(null);
  const oLogoRef = useRef(null);
  const oLogoContainerRef = useRef(null);
  const mottoRef = useRef(null);
  const contentRef = useRef(null);
  const oHeroRef = useRef(null);

  const leftCurtainRef = useRef(null);
  const rightCurtainRef = useRef(null);
  const scrollToRevealRef = useRef(null);
  const contentAboveRef = useRef(null);
  const contentBelowRef = useRef(null);
  const beforeContinueContainerRef = useRef(null);

  const sidebarRef = useRef(null);
  const headerRef = useRef(null);
  const homeSectionRef = useRef(null);
  const aboutSectionRef = useRef(null);
  const about1Ref = useRef(null);
  const about2Ref = useRef(null);
  const about3Ref = useRef(null);
  const about4Ref = useRef(null);
  const about1TextRef = useRef(null);
  const about2TextRef = useRef(null);
  const about3TextRef = useRef(null);
  const about4TextRef = useRef(null);

  const serviceSectionRef = useRef(null);
  const contactSectionRef = useRef(null);

  useEffect(() => {
    if (!leftCurtainRef.current || !rightCurtainRef.current) {
      console.error("Missing references for curtains.");
      return;
    }

    // INITIAL STATES
    gsap.set(leftCurtainRef.current, { x: "0%" });
    gsap.set(rightCurtainRef.current, { x: "0%" });
    gsap.set(scrollToRevealRef.current, { opacity: 1 });
    gsap.set(contentAboveRef.current, { opacity: 1 });
    gsap.set(brandLogoRef.current, {
      opacity: 1,
      scale: 1,
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
    });
    gsap.set(oLogoContainerRef.current, {
      zIndex: 10,
    });
    gsap.set(oLogoRef.current, {
      opacity: 1,
      background: "var(--primary)",
      position: "fixed",
      width: "92px",
      height: "92px",
      top: "50%",
      left: "50%",
      borderRadius: "100%",
      transform: "translate(30%, -150%)",
    });
    gsap.set(oHeroRef.current, {
      opacity: 0,
    });
    gsap.set(mottoRef.current, {
      opacity: 0,
      scale: 0.5,
      textAlign: isMobile ? "center" : "left",
      transform: isMobile ? "translate(-50%, 100%)" : "translate(20%, 50%)",
    });
    gsap.set(sidebarRef.current, {
      opacity: 0,
    });
    gsap.set(contentRef.current, {
      width: "100vw",
      position: "fixed",
      top: 0,
      left: "100%",
      minHeight: "100vh",
    });
    gsap.set(headerRef.current, {
      width: "100vw",
      position: "fixed",
      top: 0,
      left: "100%",
    });
    gsap.set(about1Ref.current, {
      width: (deviceSize === "xs" || deviceSize === "sm") ? "45px" : deviceSize === "md" ? "60px" : deviceSize === "lg" ? "110px" : "110px",
      // width: deviceSize === "xl" ? "110px" : deviceSize === "lg" ? "110px" : deviceSize === "md" ? "60px" : "45px",
    });
    gsap.set(about2Ref.current, {
      width: (deviceSize === "xs" || deviceSize === "sm") ? "45px" : deviceSize === "md" ? "60px" : deviceSize === "lg" ? "110px" : "110px",
    });
    gsap.set(about3Ref.current, {
      width: (deviceSize === "xs" || deviceSize === "sm") ? "45px" : deviceSize === "md" ? "60px" : deviceSize === "lg" ? "110px" : "110px",
    });
    gsap.set(about4Ref.current, {
      width: (deviceSize === "xs" || deviceSize === "sm") ? "45px" : deviceSize === "md" ? "60px" : deviceSize === "lg" ? "110px" : "110px",
    });
    gsap.set(about1TextRef.current, {
      opacity: 0,
    });
    gsap.set(about2TextRef.current, {
      opacity: 0,
    });
    gsap.set(about3TextRef.current, {
      opacity: 0,
    });
    gsap.set(about4TextRef.current, {
      opacity: 0,
    });

    // (#) CURTAIN | 10-90
    const curtain1Timeline = gsap.timeline({
      scrollTrigger: {
        trigger: contentBelowRef.current,
        start: "10% top",
        end: "50% bottom",
        scrub: false,
        markers: marker,
        onEnter: () => curtain1Timeline.play(),
        onLeaveBack: () => curtain1Timeline.reverse(),
      },
    });
    // CURTAIN HALF | HIDE SCROLL TO REVEAL
    curtain1Timeline.to(leftCurtainRef.current, {
      x: "-30%",
      ease: "linear.inOut",
      duration: 2,
    });
    curtain1Timeline.to(
      rightCurtainRef.current,
      {
        x: "30%",
        ease: "linear.inOut",
        duration: 2,
      },
      "<"
    );
    curtain1Timeline.to(
      scrollToRevealRef.current,
      {
        opacity: 0,
        ease: "linear.inOut",
        duration: 2,
      },
      "<"
    );
    curtain1Timeline.to(
      oLogoRef.current,
      {
        opacity: 1,
        top: "50%",
        left: "50%",
        transform: "translate(30%, -150%)",
        ease: "linear.inOut",
        duration: 2
      },
      "<"
    );

    // CURTAIN FULL | OPACITY OF DODEAL
    const curtain2Timeline = gsap.timeline({
      scrollTrigger: {
        trigger: contentBelowRef.current,
        start: "30% top",
        end: "90% bottom",
        scrub: false,
        markers: marker,
        onEnter: () => curtain2Timeline.play(),
        onLeaveBack: () => curtain2Timeline.reverse(),
      },
    });
    curtain2Timeline.to(leftCurtainRef.current, {
      x: "-90%",
      ease: "linear.inOut",
      duration: 2,
    });
    curtain2Timeline.to(
      rightCurtainRef.current,
      {
        x: "90%",
        ease: "linear.inOut",
        duration: 2,
      },
      "<"
    );
    curtain2Timeline.to(
      contentAboveRef.current,
      {
        opacity: 0,
        ease: "linear.inOut",
        duration: 2
      },
      "<"
    );
    // MOVE THE LOGO AND O | MOTTO OPACITY
    const mottoTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: contentBelowRef.current,
        start: "80% bottom",
        end: "bottom bottom",
        scrub: false,
        markers: marker,
        onEnter: () => mottoTimeline.play(),
        onLeaveBack: () => mottoTimeline.reverse(),
      },
    });
    mottoTimeline.to(brandLogoRef.current, {
      opacity: 1,
      scale: 1,
      transform: isMobile ? "translate(-50%, -100%)" : "translate(-130%, -50%)",
      ease: "linear.inOut",
      duration: 2,
    });
    mottoTimeline.to(
      oLogoRef.current,
      {
        opacity: 1,
        scale: 1,
        top: "50%",
        left: "50%",
        transform: isMobile
          ? "translate(30%, -300%)"
          : "translate(-170%, -150%)",
        ease: "linear.inOut",
        duration: 2,
      },
      "<"
    );
    mottoTimeline.to(
      mottoRef.current,
      {
        opacity: 1,
        scale: 1.8,
        textAlign: isMobile ? "center" : "left",
        // transform: "translate(30%, 50%)",
        transform: isMobile ? "translate(-50%, 100%)" : "translate(30%, 50%)",
        ease: "linear.inOut",
        duration: 2,
      },
      "<"
    );
    // OPACITY OF ALL CONTENT
    const beforeContinueTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: beforeContinueContainerRef.current,
        start: "top top",
        end: "90% bottom",
        scrub: false,
        markers: marker,
        onEnter: () => beforeContinueTimeline.play(),
        onLeaveBack: () => beforeContinueTimeline.reverse(),
      },
    });
    beforeContinueTimeline.to(brandLogoRef.current, {
      opacity: 0,
      scale: 0.5,
      transform: "translate(-50%, -50%)",
      ease: "linear.inOut",
      duration: 2,
    });
    beforeContinueTimeline.to(
      oLogoContainerRef.current,
      {
        opacity: 1,
        zIndex: 10,
        ease: "linear.inOut",
        duration: 2,
      },
      "<"
    );
    beforeContinueTimeline.to(
      oLogoRef.current,
      {
        opacity: 1,
        scale: 1,
        top: "50%",
        left: "50%",
        borderTopLeftRadius: "100%",
        borderTopRightRadius: "100%",
        borderBottomLeftRadius: "100%",
        borderBottomRighttRadius: "100%",
        transform: isMobile
          ? "translate(30%, -300%)"
          : "translate(-170%, -150%)",
        ease: "linear.inOut",
        duration: 2,
      },
      "<"
    );
    beforeContinueTimeline.to(
      mottoRef.current,
      {
        opacity: 0,
        scale: 0.5,
        textAlign: isMobile ? "center" : "left",
        transform: "translate(-50%, -50%)",
        ease: "linear.inOut",
        duration: 2,
      },
      "<"
    );
    // SCROLL TO CONTENT REF SECTION
    const slideToContentTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: beforeContinueContainerRef.current,
        start: "center center",
        end: "bottom bottom",
        scrub: false,
        markers: marker,
        onEnter: () => slideToContentTimeline.play(),
        onLeaveBack: () => slideToContentTimeline.reverse(),
      },
    });
    slideToContentTimeline.to(
      contentRef.current,
      {
        left: "0%",
        opacity: 1,
        ease: "linear.inOut",
        duration: 2,
      },
      "<"
    );
    slideToContentTimeline.to(
      headerRef.current, {
      left: "0%",
      opacity: 1,
      ease: "linear.inOut",
      duration: 2,
    },
      "<"
    );
    slideToContentTimeline.to(
      sidebarRef.current,
      {
        opacity: 1,
        ease: "linear.inOut",
        duration: 2,
      },
      "<"
    );
    slideToContentTimeline.to(oLogoContainerRef.current, {
      opacity: 1,
      zIndex: 10,
      ease: "linear.inOut",
      duration: 1,
    }, "<");
    slideToContentTimeline.to(oLogoRef.current, {
      opacity: 1,
      scale: 1,
      top: "50%",
      left: "50%",
      height: isMobile ? "100px" : "150px",
      width: isMobile ? "200px" : "300px",
      borderTopLeftRadius: "100px",
      borderTopRightRadius: "100px",
      borderBottomLeftRadius: "0px",
      borderBottomRighttRadius: "0px",
      backgroundImage: "linear-gradient(to bottom right, var(--secondary), var(--primary)",
      boxShadow: "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
      transform: isMobile
        ? "translate(100%, -300%)"
        : "translate(2%, 55%)",
      ease: "linear.inOut",
      duration: 1,
    }, "<");
    // <div
    //       className="absolute bottom-0 right-[7%] w-[200px] h-[100px] lg:w-[300px] lg:h-[150px] rounded-t-full"
    //       style={{
    //         backgroundImage:
    //           "linear-gradient(to bottom right, var(--secondary), var(--primary)",
    //         boxShadow:
    //           "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
    //         zIndex: -1,
    //       }}
    //     ></div>
    slideToContentTimeline.to(
      oHeroRef.current,
      {
        opacity: 1,
        scale: 1,
        width: "75px",
        height: "75px",
        ease: "linear.inOut",
        duration: 2,
      },
      "<"
    );
    // O IN ABOUT 
    // const oInAboutSectiontimeline = gsap.timeline({
    //   scrollTrigger: {
    //     trigger: homeSectionRef.current,
    //     start: "top center",
    //     end: "90% bottom",
    //     scrub: 1,
    //     markers: marker,
    //   }
    // });
    // oInAboutSectiontimeline.to(oLogoRef.current, {
    //   // and hide relative o 
    // });

    // HIDE NAVBAR WHEN USER REACHED CONTACT SECTION 
    const navbarInContactTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: serviceSectionRef.current,
        start: "80% top",
        end: "center bottom",
        scrub: false,
        markers: marker,
        onEnter: () => navbarInContactTimeline.play(),
        onLeaveBack: () => navbarInContactTimeline.reverse(),
      },
    });
    navbarInContactTimeline.to(
      sidebarRef.current,
      {
        opacity: 0,
        ease: "linear.inOut",
        duration: 2,
      },
      "<"
    );

    // O IN ABOUT 
    const aboutOTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: aboutSectionRef.current,
        start: "-300px top",
        end: "top top",
        scrub: false,
        markers: marker,
        onEnter: () => aboutOTimeline.play(),
        onLeaveBack: () => aboutOTimeline.reverse(),
      },
    });
    aboutOTimeline.to(oLogoRef.current, {
      opacity: 1,
      scale: 2,
      zIndex: 105,
      top: "50%",
      left: "50%",
      height: "75px",
      width: "75px",
      borderTopLeftRadius: "100px",
      borderTopRightRadius: "100px",
      borderBottomLeftRadius: "0px",
      borderBottomRighttRadius: "0px",
      // transform: isMobile
      //   ? "translate(3%, 213.5%)"
      //   : "translate(100%, 100%)",
      ease: "linear.inOut",
      duration: 1,
    }, "<");

    // ABOUT REF 
    const aboutCirclesTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: aboutSectionRef.current,
        start: isMobile ? "-400px top" : "-40px top",
        end: "top top",
        scrub: false,
        markers: marker,
        onEnter: () => aboutCirclesTimeline.play(),
        onLeaveBack: () => aboutCirclesTimeline.reverse(),
      },
    });
    aboutCirclesTimeline.to(
      about1Ref.current,
      {
        width: (deviceSize === "sm" || deviceSize === "xs") ? "90px" : deviceSize === "md" ? "120px" : deviceSize === "lg" ? "220px" : "220px",
        ease: "linear.inOut",
        duration: 1,
      },
    );
    aboutCirclesTimeline.to(
      about2Ref.current,
      {
        width: (deviceSize === "sm" || deviceSize === "xs") ? "90px" : deviceSize === "md" ? "120px" : deviceSize === "lg" ? "220px" : "220px",
        ease: "linear.inOut",
        duration: 1.4,
      },
      "<"
    );
    aboutCirclesTimeline.to(
      about3Ref.current,
      {
        width: (deviceSize === "sm" || deviceSize === "xs") ? "90px" : deviceSize === "md" ? "120px" : deviceSize === "lg" ? "220px" : "220px",
        ease: "linear.inOut",
        duration: 1.8,
      },
      "<"
    );
    aboutCirclesTimeline.to(
      about4Ref.current,
      {
        width: (deviceSize === "sm" || deviceSize === "xs") ? "90px" : deviceSize === "md" ? "120px" : deviceSize === "lg" ? "220px" : "220px",
        ease: "linear.inOut",
        duration: 2.2,
      },
      "<"
    );
    aboutCirclesTimeline.to(
      about1TextRef.current,
      {
        opacity: 1,
        ease: "linear.inOut",
        duration: 1,
      },
      "<"
    );
    aboutCirclesTimeline.to(
      about2TextRef.current,
      {
        opacity: 1,
        ease: "linear.inOut",
        duration: 1.4,
      },
      "<"
    );
    aboutCirclesTimeline.to(
      about3TextRef.current,
      {
        opacity: 1,
        ease: "linear.inOut",
        duration: 1.8,
      },
      "<"
    );
    aboutCirclesTimeline.to(
      about4TextRef.current,
      {
        opacity: 1,
        ease: "linear.inOut",
        duration: 2.2,
      },
      "<"
    );

    // CLEAN UP SCROLL TRIGGER ON COMPONENT UNMOUNT
    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, [isMobile, deviceSize]);

  return (
    <div className="relative">
      <NoiseBackground />
      <div
        ref={oLogoContainerRef}
        className="w-[100vw] h-[100vh] fixed"
      >
        {/* O OVERALL */}
        <div
          ref={oLogoRef}
          style={{
            zIndex: 103,
          }}
          className="primary-bg"
        ></div>
      </div>
      <div className="relative w-[100vw] h-full">
        {/* D HERO */}
        <div
          ref={brandLogoRef}
          className="fixed bg-white w-[215px] h-[275px] rounded-r-full"
          style={{
            zIndex: 9,
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        ></div>
        {/* MOTTO */}
        <div
          ref={mottoRef}
          className="fixed uppercase text-2xl font-bold"
          style={{
            top: "50%",
            left: "50%",
            transform: "translate(-50%, 0%)",
            zIndex: 9,
          }}
        >
          Your success
          <br />
          Our deal
        </div>
        {/* CONTENT ABOVE CURTAIN */}
        <div
          ref={contentAboveRef}
          className="content-above fixed top-0 left-0 w-[100vw] h-[100vh]"
          style={{
            zIndex: 100,
          }}
        >
          <div className="relative w-full h-full flex flex-col gap-5 items-center justify-between py-5">
            <div className="p-5"></div>
            <div className="flex flex-col gap-4 justify-center items-center">
              <div className="hero-brand grad-anim">DODEAL</div>
              <div
                ref={scrollToRevealRef}
                className="uppercase text-xs grad-anim"
              >
                Scroll to reveal
              </div>
            </div>
            <div className="p-5">
              <div className="p-2 border border-[var(--gold-3)] rounded-full">
                <PiArrowDownLight className="grad-anim" size={16} />
              </div>
            </div>
          </div>
        </div>
        {/* CURTAINS */}
        <div
          className="fixed w-[100vw] h-[100vh] overflow-hidden"
          style={{
            zIndex: 99,
          }}
        >
          {/* CURTAIN ANIMATION */}
          <div
            className="curtainBody absolute top-0 left-0 w-full h-full"
            style={{
              zIndex: 99,
            }}
          >
            {/* LEFT CURTAIN */}
            <div
              ref={leftCurtainRef}
              className="curtainContainer left-0"
              style={{
                transform: "translateX(0%)",
                zIndex: 99,
              }}
            >
              {Array.from({ length: 12 }).map((_, index) => (
                <div
                  key={index}
                  className="unCurtain"
                  style={{
                    animationDelay: `-${index * 0.1}s`,
                  }}
                ></div>
              ))}
            </div>
            {/* RIGHT CURTAIN */}
            <div
              ref={rightCurtainRef}
              className="curtainContainer right-0"
              style={{
                transform: "translateX(0%)",
                zIndex: 99,
              }}
            >
              {Array.from({ length: 12 }).map((_, index) => (
                <div
                  key={index}
                  className="unCurtain"
                  style={{
                    animationDelay: `-${index * 0.1}s`,
                  }}
                ></div>
              ))}
            </div>
          </div>
        </div>
        {/* SECOND - DUMMY CONTENT */}
        <div
          ref={contentBelowRef}
          className="w-[100vw] h-[300vh]"
          style={{
            zIndex: 90,
          }}
        ></div>
        {/* BEFORE CONTENT */}
        <div
          ref={beforeContinueContainerRef}
          className="relative w-full h-[100vh] flex flex-col items-center justify-center"
        ></div>

        <div className="relative w-full h-[50vh]"></div>
      </div>

      {/* HEADER */}
      <div
        ref={headerRef}
        className="fixed top-0 py-5"
        style={{
          zIndex: 105,
        }}
      >
        <Header routes={routes} />
      </div>

      {/* STICKY NAVBAR */}
      <div
        ref={sidebarRef}
        className={`fixed top-0 left-0 flex flex-col justify-center items-center h-screen z-40 transition-all duration-300 mx-2 ${!isMobile
          ? "w-28 lg:w-20" : "hidden"
          }`}
        style={{
          zIndex: 103,
        }}
      >
        <div className="text-white">
          <nav
            className={`relative flex flex-col gap-2 py-5 items-center transition-all duration-300`}
          >
            <span
              className={`absolute top-0 left-1/2 h-full w-2 blur-sm opacity-50 rounded-full bg-[#375a69] transform -translate-x-1/2 transition-all duration-300`}
              style={{
                transformOrigin: "center",
                // zIndex: -1
              }}
            ></span>
            {links?.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick(link.id);
                }}
                className={`transition-all duration-300 ${activeLink === link?.id
                  ? `text-white font-bold text-lg scale-125`
                  : `text-[#727272] opacity-70 font-bold text-base hover:opacity-100`
                  }`}
              >
                {link?.label}
              </a>
            ))}
          </nav>
        </div>
      </div>

      {/* HOME HERO */}
      <div
        ref={contentRef}
        className="w-[100vw] min-h-[100vh] fixed top-0 overflow-x-hidden text-center py-5"
        style={{
          zIndex: 101,
        }}
      >
        {/* HERO */}
        <div
          ref={homeSectionRef}
          id="home"
          className="w-full min-h-[100vh] flex flex-col pb-5 gap-5 items-center justify-between"
        >
          <div className="h-[30px]"></div>
          {/* SECONDARY HERO */}
          <div className="padding-container text-center flex flex-col items-center justify-center">
            <div className="hero-text uppercase font-bold">
              Every deal
              <br />
              starts with
            </div>
            <div className="flex items-center justify-center gap-2">
              <div className="hero-text uppercase font-bold">D</div>
              <div
                ref={oHeroRef}
                className="w-[75px] h-[75px] rounded-full primary-bg mt-[5px]"
              ></div>
            </div>
          </div>
          {/* TEXT OVER CIRCLE */}
          <div
            className="padding-container w-full flex justify-end"
            style={{
              color: "var(--l-gray)",
            }}
          >
            <div className="w-[300px] text-start text-sm me-[10%] pb-5">
              By merging innovation, adaptability, and excellence, we redefine
              how opportunities are discovered, developed, and delivered
              across industries.
            </div>
          </div>
        </div>
        {/* (1) HALF CIRCLE*/}
        {/* <div
          className="absolute bottom-0 right-[7%] w-[200px] h-[100px] lg:w-[300px] lg:h-[150px] rounded-t-full"
          style={{
            backgroundImage:
              "linear-gradient(to bottom right, var(--secondary), var(--primary)",
            boxShadow:
              "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
            zIndex: -1,
          }}
        ></div> */}
      </div>

      {/* CONTINUITY CONTENT */}
      <div
        ref={aboutSectionRef}
        className="relative secondary-bg w-full min-h-[100vh] rounded-t-[50px]"
        style={{
          zIndex: 102,
        }}
      >
        <NoiseBackgroundAbsolute rounded={"rounded-t-[50px]"} />
        {/* ABOUT SECTION */}
        <div
          id="about"
          className="relative py-5 text-center min-h-[50vh] lg:min-h-[100vh] flex items-center justify-center"
        >
          {/* (2) HALF CIRCLE*/}
          <div
            className="absolute top-0 right-[7%] w-[200px] h-[100px] lg:w-[300px] lg:h-[150px] rounded-t-full"
            style={{
              backgroundImage:
                "linear-gradient(to bottom right, var(--secondary), var(--primary)",
              boxShadow:
                "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
              zIndex: -1,
            }}
          ></div>
          {/* <About /> */}
          <div className="w-full padding-container my-5 py-5 text-center">
            <div className="grid grid-cols-4 gap-5 lg:gap-10 my-5 py-5">
              <div className="col-span-4 lg:col-span-3">
                <div className="subhero-text uppercase font-bold">
                  We Redefine Possibilities
                </div>
                <div className="hidden lg:flex h-[50px]"></div>
              </div>
              <div className="hidden md:flex lg:hidden col-span-2"></div>
              <div className="col-span-4 md:col-span-2 lg:col-span-1 text-sm text-[var(--l-gray)] flex items-end text-start">
                At DODEAL, we merge innovation, strategy, and technology to deliver
                tailored solutions that empower businesses and individuals. Our
                data-driven approach ensures every opportunity is optimized for
                success, creating lasting value for our partners.
              </div>
            </div>
            {/* <FeaturesSection /> */}
            <div className="my-5 py-5 flex items-center justify-center">
              <div className="grid grid-cols-2 items-center justify-center">
                {/* 1T / 2I */}
                <div className="h-[45px] w-[180px] md:h-[60px] md:w-[240px] lg:h-[110px] lg:w-[440px] flex justify-start">
                  <div
                    ref={about1Ref}
                    className="flex items-center justify-center"
                  // className="w-[90px] md:w-[120px] lg:w-[220px] flex items-center justify-center"
                  >
                    <div
                      ref={about1TextRef}
                      className="uppercase font-bold text-xs md:text-base lg:text-xl"
                    >
                      Worldwide
                      <br />
                      Approach
                    </div>
                  </div>
                  <div
                    className="primary-bg rounded-none rounded-t-full h-[45px] w-[90px] md:h-[60px] md:w-[120px] lg:h-[110px] lg:w-[220px] flex items-center justify-center"
                    style={{
                      boxShadow:
                        "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
                    }}
                  >
                    <PiBrainLight size={deviceSize === "xl" ? 50 : deviceSize === "lg" ? 50 : deviceSize === "md" ? 35 : 20} className={`text-white`} />
                  </div>
                </div>
                {/* 3T / 4I */}
                <div className="h-[45px] w-[180px] md:h-[60px] md:w-[240px] lg:h-[110px] lg:w-[440px] flex justify-start">
                  <div
                    ref={about2Ref}
                    className="flex items-center justify-center"
                  // w-[45px] md:w-[60px] lg:w-[110px]
                  // className="w-[90px] md:w-[120px] lg:w-[220px] flex items-center justify-center"
                  >
                    <div
                      ref={about2TextRef}
                      className="uppercase font-bold text-xs md:text-base lg:text-xl"
                    >
                      Experienced
                      <br />
                      Team
                    </div>
                  </div>
                  <div
                    className="primary-bg rounded-none rounded-t-full h-[45px] w-[90px] md:h-[60px] md:w-[120px] lg:h-[110px] lg:w-[220px] flex items-center justify-center"
                    style={{
                      boxShadow:
                        "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
                    }}
                  >
                    <PiFireLight size={deviceSize === "xl" ? 50 : deviceSize === "lg" ? 50 : deviceSize === "md" ? 35 : 20} className={`text-white`} />
                  </div>
                </div>
                {/* 1I / 2T */}
                <div className="h-[45px] w-[180px] md:h-[60px] md:w-[240px] lg:h-[110px] lg:w-[440px] flex justify-end">
                  <div
                    className="primary-bg rounded-none rounded-b-full h-[45px] w-[90px] md:h-[60px] md:w-[120px] lg:h-[110px] lg:w-[220px] flex items-center justify-center"
                    style={{
                      boxShadow:
                        "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
                    }}
                  >
                    <PiGlobeLight size={deviceSize === "xl" ? 50 : deviceSize === "lg" ? 50 : deviceSize === "md" ? 35 : 20} className={`text-white`} />
                  </div>
                  <div
                    ref={about3Ref}
                    className="flex items-center justify-center"
                  >
                    <div
                      ref={about3TextRef}
                      className="uppercase font-bold text-xs md:text-base lg:text-xl"
                    >
                      Creative
                      <br />
                      Solutions
                    </div>
                  </div>
                </div>
                {/* 3I / 4T */}
                <div className="h-[45px] w-[180px] md:h-[60px] md:w-[240px] lg:h-[110px] lg:w-[440px] flex justify-end">
                  <div
                    className="primary-bg rounded-none rounded-b-full h-[45px] w-[90px] md:h-[60px] md:w-[120px] lg:h-[110px] lg:w-[220px] flex items-center justify-center"
                    style={{
                      boxShadow:
                        "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
                    }}
                  >
                    <PiUsersLight size={deviceSize === "xl" ? 50 : deviceSize === "lg" ? 50 : deviceSize === "md" ? 35 : 20} className={`text-white`} />
                  </div>
                  <div
                    ref={about4Ref}
                    className="flex items-center justify-center"
                  >
                    <div
                      ref={about4TextRef}
                      className="uppercase font-bold text-xs md:text-base lg:text-xl"
                    >
                      Blazing
                      <br />
                      Start
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* SERVICES SECTION */}
        <div
          id="services"
          ref={serviceSectionRef}
          className="relative py-5 min-h-[100vh] flex items-center justify-center"
        >
          <Services />
        </div>
        {/* CONTACT SECTION */}
        <div
          ref={contactSectionRef}
          className="relative py-5 text-center min-h-[100vh] flex items-center justify-center"
        >
          <Contact />
        </div>


        {/* FOOTER */}
        <Footer />

      </div>
      {/* LEAVE IT FOR NOW  */}
      {/* <div className="relative w-full h-[5vh] flex flex-col items-center justify-center"></div> */}
    </div>
  );
}

export default Home1;
